import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import styles from "./stylesAdmin.module.css"
import { Identifiable } from '../../types/interfaces';
import { useLoading } from "../../components/LoadingContext";
import { useAppContext } from '../../components/AppContext';

interface DeleteModalProps<T extends Identifiable> {
  show: boolean;
  onHide: () => void;
  onDeleteItem: (item: T) => Promise<void>;
  item: T | null;
  itemLabel: string;
  apiUrl: string;
  showNotification: (message: string, variant: "success" | "danger") => void;
}

const DeleteModal = <T extends Identifiable>({
  show,
  onHide,
  onDeleteItem,
  item,
  apiUrl,
  showNotification,
}: DeleteModalProps<T>) => {
    const { user } = useAppContext() 
    const { setLoading } = useLoading();
    const handleDeleteItem = async () => {
      if (!user) {
        console.error('User not found');
        return;
      }
      setLoading(true);
        if (item) {
          try {
            const response = await fetch(
              `${apiUrl}/${item.id}`,
              {
                method: "PUT",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({ activo: 0, userEmail: user.email, }),
                credentials: "include"
              }
            );
      
            if (!response.ok) {
              throw new Error("Error al desactivar el ítem");
            }
            showNotification("Se ha eliminado con éxito", "success");
            await onDeleteItem(item);
            onHide();
          } catch (error) {
            showNotification("No se puede eliminar porque tiene otros elementos asignados. Por favor, reasigne los otros elementos antes de proceder.", "danger");
            onHide();
            console.error("Error deleting item:", error);
          } finally {
            setLoading(false);
          }
        }
    };

  return (
    <Modal show={show} onHide={onHide} className={styles.modalContainer}>
      <Modal.Header closeButton className={styles.modalHeader}>
        <Modal.Title className={styles.modalTitle}>Confirmar Eliminación</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.modalBody}>{`¿Está seguro/a de que desea eliminar este elemento?`}</Modal.Body>
      <Modal.Footer className={styles.modalFooter}>
        <Button variant="secondary" onClick={onHide}>
          Cancelar
        </Button>
        <Button variant="danger" onClick={handleDeleteItem}>
          Eliminar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteModal;
